module.exports = __webpack_public_path__ + "img/2_dp.ad47b945.png";